import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons/faRotateLeft';
import { Button } from '../button';
import { Icon } from '../icon';
export const TryAgainButton = ({ children, ...props }) => {
    return (_jsxs(Button, { ...props, variation: "secondary", size: "small", children: [_jsx(Icon, { icon: faRotateLeft }), children] }));
};
